module.exports = __webpack_public_path__ + "img/ileti_coding.66f82b93.svg";